module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADISURBVChTnZI9CoQwEIU9XCrBSkjlGaw8gM22W6SysdxatvYEC0Iqz6DlQipBeJvRGMeflWUfvCYznzN5McAf2kK9xvOeQUYCQlhHEtntgVfv6k4e6uockhqtk1LDvA10mcywkMjrznU6yDTKA+S0mhu6KvVnBKrGTOcBxhZFvAKXjgu0I0FaIWSFZQppO4kcQmkL7QvTfYZv0PzRA7QULqH9ekvhHHLr7YPg62HgsVv7IKx45DwI0jqNR+7EH/fok8f1+uk3Aj5Oi90nIGNLAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tipp_icon.png
// module id = owYJ
// module chunks = 1